<template>
  <div class="wrap">
    <div class="inner-box">
      <div class="mt20">
        <el-input placeholder="供应商名称" class="w350 seekIpt" v-model="searchInput" @keyup.enter.native="search">
          <i slot="suffix" class="el-input__icon el-icon-search" @click="search"></i>
        </el-input>
        <el-cascader class="ml20 w300" v-model="areaCode" :options="areaList.options" @change="areaChange"
                     :props="areaList.props" clearable placeholder="所属行政区" ref="cascader"></el-cascader>
        <el-select class="ml20 w120" v-model="tobIsBind" @change="bindChange" clearable placeholder="TOB绑定状态">
          <el-option v-for="item in isBindKeyValue" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
        <el-select class="ml20 w120" v-model="fillIsBind" @change="bindChange" clearable placeholder="填报绑定状态">
          <el-option v-for="item in isBindKeyValue" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </div>
      <div style="margin-top: 10px;">
        <el-table :data="tableData" border style="width: calc(100% - 10px);" :cell-style="{'text-align': 'center'}" :header-cell-style="{'text-align': 'center'}" v-loading="tableLoading">
          <el-table-column label="序号" width="80" type=index >
            <template slot-scope="scope">
              {{(page.pageSize * (page.pageNum - 1) + scope.$index + 1)}}
            </template>
          </el-table-column>
          <el-table-column prop="sname" label="省平台供应商名称" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.sname ? scope.row.sname: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="socialCreditCode" label="省平台供应商代码" min-width="140" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.socialCreditCode ? scope.row.socialCreditCode: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="schoolname" label="省平台校区名称" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.schoolname ? scope.row.schoolname: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="prAreaName" label="对接区域" min-width="80" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.prAreaName ? scope.row.prAreaName: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="tobSupplyName" label="TOB供应商名称" min-width="140" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.tobSupplyName ? scope.row.tobSupplyName: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="tobIsBind" label="TOB是否绑定" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.tobIsBind ? scope.row.tobIsBind: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="tobBindTime" label="TOB绑定时间" min-width="140" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.tobBindTime ? scope.row.tobBindTime: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="fillSupplyName" label="填报供应商名称" min-width="140" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.fillSupplyName ? scope.row.fillSupplyName: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="fillIsBind" label="填报是否绑定" min-width="120" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.fillIsBind ? scope.row.fillIsBind: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="fillBindTime" label="填报绑定时间" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.fillBindTime ? scope.row.fillBindTime: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="fillEntityName" label="填报主体名称" min-width="140" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.fillEntityName ? scope.row.fillEntityName: '-'}}
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.createTime ? scope.row.createTime: '-'}}
            </template>
          </el-table-column>
          <!--<el-table-column prop="updateTime" label="更新时间" min-width="160" show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.updateTime ? scope.row.updateTime: '-'}}
            </template>
          </el-table-column>-->
          <el-table-column fixed="right" label="操作" min-width="200">
            <template slot-scope="scope">
              <el-button v-if="scope.row.tobIsBind === '未绑定'" @click="toTobBind(scope.row)" type="primary" plain size="small">TOB绑定</el-button>
              <el-button v-if="scope.row.tobIsBind === '已绑定'" @click="toTobUnbind(scope.row)" type="warning" plain size="small">TOB解绑</el-button>
              <el-button v-if="scope.row.fillIsBind === '未绑定'" @click="toFillBind(scope.row)" type="primary" plain size="small">填报绑定</el-button>
              <el-button v-if="scope.row.fillIsBind === '已绑定'" @click="toFillUnbind(scope.row)" type="warning" plain size="small">填报解绑</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <ybPagination :page="page" @size-change="pageSizeChange" @current-change="pageCurrentChange" style="margin-top:10px; margin-right:10px"></ybPagination>
      <supplier-tob-dialog v-if="proSupplierTobDialogVisible" :tobSupplierData="tobSupplierData" :pro-supplier-tob-dialog-visible="proSupplierTobDialogVisible" @closeTobSupplierDialogVisible="closeTobSupplierDialogVisible"></supplier-tob-dialog>
      <supplier-fill-dialog v-if="proSupplierFillDialogVisible" :fillSupplierData="fillSupplierData" :pro-supplier-fill-dialog-visible="proSupplierFillDialogVisible" @closeFillSupplierDialogVisible="closeFillSupplierDialogVisible"></supplier-fill-dialog>
    </div>
  </div>
</template>
<script>

import * as subManageApi from '@/api/subManage'
import * as prConnectApi from '@/api/prConnectprovincial'
import ybPagination from '@/components/ybPagination'
import * as mapping from '@/utils/enumList'
import SupplierFillDialog from "views/province/SupplierFillDialog"
import SupplierTobDialog from "views/province/SupplierTobDialog";
;
export default {
  name: 'supplierList',
  components: {
    SupplierTobDialog,
    SupplierFillDialog,
    ybPagination
  },
  data() {
    return {
      searchInput: '',
      parentId: '0',
      areaCode:'',
      areaId:'',
      isBindKeyValue: mapping.getKeyVal('prBindType'),
      tobIsBind: '',
      fillIsBind:'',
      tableLoading: false,
      tableData: [],
      areaList: {
        selOptions: [],
        options: [],
        parentCode: '',
        props: {
          checkStrictly: true,
          expandTrigger: 'hover',
          value: 'areaId',
          label: 'areaName',
          children: 'children',
          lazy: true,
          lazyLoad(node, resolve) {}
        }
      },
      page: {
        pageSize: 10,
        pageNum: 1,
        total: 10
      },
      fillSupplierData: {
        campusid: '',
        prAreaId: '',
      },
      tobSupplierData: {
        campusid: '',
        prAreaId: '',
      },
      proSupplierTobDialogVisible: false,
      proSupplierFillDialogVisible: false
    }
  },
  computed: {
    params: function() {
      return {
        current: this.page.pageNum,
        keyword: this.searchInput,
        areaId: this.areaId,
        size: this.page.pageSize,
        tobIsBind: this.tobIsBind,
        fillIsBind: this.fillIsBind
      }
    }
  },
  methods: {
    // 搜索
    search() {
      this.page.pageNum = 1;
      this.tableRefresh()
    },
    // 点击区域节点前的圆圈进行选择
    areaChange(val) {
      this.page.pageNum = 1
      if(val==undefined){
        val = [];
      }
      this.areaList.selectedOptions = val;
      this.areaId = this.areaList.selectedOptions[this.areaList.selectedOptions.length-1]
      this.tableRefresh();
    },
    // 绑定状态筛选
    bindChange(value) {
      this.page.pageNum = 1
      this.tableRefresh()
    },
    tableRefresh() {
      this.tableLoading = true
      prConnectApi.getSupplier(this.params).then(r => {
        if(r.code === 200) {
          let data = r.data.records
          data.forEach(el => {
            el.tobIsBind = mapping.keyToVal('prBindType', el.tobIsBind),
            el.fillIsBind = mapping.keyToVal('prBindType', el.fillIsBind)
          })
          this.tableData = data
          this.page.total = parseInt(r.data.total)
        }
        this.tableLoading = false;
      }).catch(err => {})
    },
    // 绑定
    toTobBind(row) {
      this.tobSupplierData.campusid = row.campusid;
      this.tobSupplierData.prAreaId = row.prAreaId;
      this.proSupplierTobDialogVisible = true;
    },
    // 解绑
    toTobUnbind(row) {
      this.$confirm('确认要将供应商解除绑定？！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        prConnectApi.unBindTobSupplier({id: row.sid}).then(r => {
          if(r.code === 200) {
            this.$message.success('解绑成功')
            this.tableRefresh()
          }
        }).catch(err => {})
      }).catch(e => {});
    },
    // 绑定
    toFillBind(row) {
      this.fillSupplierData.sid = row.sid;
      this.fillSupplierData.sname = row.sname;
      this.fillSupplierData.prAreaId = row.prAreaId;
      this.proSupplierFillDialogVisible = true;
    },
    // 解绑
    toFillUnbind(row) {
      this.$confirm('确认要将供应商解除绑定？！', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        prConnectApi.unBindFillSupplier({id: row.sid}).then(r => {
          if(r.code === 200) {
            this.$message.success('解绑成功')
            this.tableRefresh()
          }
        }).catch(err => {})
      }).catch(e => {});
    },
    // 关闭弹窗
    closeTobSupplierDialogVisible() {
      this.proSupplierTobDialogVisible = false;
    },
    // 关闭弹窗
    closeFillSupplierDialogVisible() {
      this.proSupplierFillDialogVisible = false;
    },
    // 页数改变
    pageCurrentChange(num) {
      if(num !== this.page.pageNum) {
        this.page.pageNum = num;
        this.tableRefresh();
      }
    },
    // 页数据量改变
    pageSizeChange(size) {
      if(size !== this.page.pageSize) {
        this.page.pageSize = size;
        this.tableRefresh();
      }
    }
  },
  created() {
    let that = this;
    that.areaList.props.lazyLoad = function (node, resolve) {
      let code = node.value ? node.value : that.parentId;
      if (code.length > 6) {
        return resolve([])
      }
      subManageApi.getAreaList({
        parentId: code
      }).then(r => {
        if (r.code === 200) {
          resolve(r.data)
        }
      });
    }
    this.tableRefresh();
  }
}
</script>
<style lang="scss" scoped>
.wrap {
  width: 100%;
  height: calc(100% - 40px);
  text-align: left;
}
</style>
